import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./styles.css";

class QuestionnaireProgress extends Component {
  render() {
    const { questionnaires, match } = this.props;
    const { id } = match.params;

    return (
      <div className="questionnaire-progress">
        {questionnaires.map(question => (
          <div
            key={question._id}
            style={{ width: 100 / questionnaires.length - 0.25 + "%" }}
            className={question.questionNumber <= +id ? "active" : ""}
          />
        ))}
      </div>
    );
  }
}

export default withRouter(QuestionnaireProgress);



// WEBPACK FOOTER //
// ./src/components/QuestionnaireProgress/QuestionnaireProgress.js